// Library Imports
import React from 'react';
import { Link } from 'react-router-dom';

// Local Imports
import { AppSettingsIcon, AvatarIcon, LogoutIcon } from '../../../assets/icons'
import { persistor, useAppDispatch, useAppSelector } from '../../../redux/store'
import { logout } from '../../../redux/features/loginUser/loginUserSlice';
import { capitalizeFirstLetter } from '../../../utils/validator';
import assets from '../../../assets';


// Menu Header
export const MenuHeader = () => {
    const { profile, loginUser } = useAppSelector((state) => state?.currentUser);
    const getFullName = Object.keys(profile)?.length > 0 ? `${profile?.data?.firstName?.trim()} ${profile?.data?.lastName?.trim()}` : loginUser?.data?.name
    return (
        <React.Fragment>
            <span className="hidden text-right sm:block">
                <span className="block text-sm font-medium text-black/80">
                    {getFullName ? capitalizeFirstLetter(getFullName) : "Administrator"}
                </span>
            </span>

            <span className="text-gray-500">
                {profile?.data?.profileImage?.Location ? <img
                    src={profile?.data?.profileImage?.Location}
                    onError={(e) => { e.currentTarget.src = assets.avatar; e.currentTarget.className = 'w-[40px] h-[40px] border-none object-cover object-center rounded-full' }}
                    className='w-[40px] h-[40px] border object-cover object-center rounded-full'
                    alt="Profile"
                /> :
                    <AvatarIcon />}
            </span>
        </React.Fragment>
    )
}

// Menu List
export const MenuList = () => {
    const dispatch = useAppDispatch();

    const handleLogout = () => {
        dispatch(logout());
        persistor.purge();
    }
    return (
        <React.Fragment>
            <Link to="/profile">
                <div className="flex items-center gap-3 !text-gray-600 text-sm font-normal duration-100 ease-in-out  hover:bg-slate-100 px-2 py-2 lg:text-base"
                >
                    <AvatarIcon className='!h-6 !w-6' />
                    My Profile
                </div>
            </Link>

            <Link to="/app-settings">
                <div className="flex items-center gap-4 !text-gray-600 text-sm font-normal duration-100 ease-in-out  hover:bg-slate-100 px-2 py-2 lg:text-base"
                >
                    <AppSettingsIcon className='!h-5 !w-5' />
                    Settings
                </div>
            </Link>

            <div className="flex items-center gap-3.5 !text-gray-600 text-sm font-normal duration-100 ease-in-out  hover:bg-slate-100 px-2 py-2 lg:text-base" onClick={handleLogout}>
                <LogoutIcon className='!h-5 !w-5 ml-1' />
                Log Out
            </div>
        </React.Fragment>
    )
}
